import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {};

const AppointmentReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  if (type === ACTION_TYPES.FETCH_APP_SETTINGS_SUCCESS) {
    return payload?.appointment || null;
  }
  return state;
};

export default AppointmentReducer;
